import React from "react"
import { makeStyles } from "makeStyles"

const useStyles = makeStyles()(() => ({
	backgroundElement: {
		height: 2000,
		width: "90vw",
		borderRadius: 70,
		background: "linear-gradient(90deg, rgba(0,156,172,0.1) 0%, rgba(0,156,160,0.3) 100%)",
		position: "absolute",
		zIndex: 0,
		top: "83%",
		left: "-8%",
		transform: "translate(-50%, -50%) rotate(30deg)",

		"@media only screen and (max-width: 600px)": {
			bottom: "0%",
			left: "-90%",
			width: 800,
		},
		"@media only screen and (min-width: 600px) and (max-width: 960px)": {
			bottom: "20%",
			left: "-55%",
			width: 800,
		},
	},
}))

const BackgroundElement = () => {
	const { classes } = useStyles()
	return <div className={classes.backgroundElement} />
}

export default BackgroundElement
